import { MOCK_MENU } from "./mockData";

export function formatDate(dateStr, options = { year: "numeric", month: "long", day: "numeric" }) {
  if (!dateStr) return "";
  // ⚡ Ignore time & timezone — take only date part
  const [year, month, day] = dateStr.split("T")[0].split("-");
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString("en-IN", options);
}

export function toLocalISODate(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getDayForDate(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  const userTimezoneOffset = d.getTimezoneOffset() * 60000;
  const correctedDate = new Date(d.getTime() + userTimezoneOffset);
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  return days[correctedDate.getDay()];
}

export function findMenuItem(itemId) {
  // Look in localStorage (menuData saved by Home.js)
  const allMenus = JSON.parse(localStorage.getItem("menuData") || "[]");
  if (Array.isArray(allMenus) && allMenus.length > 0) {
    for (const item of allMenus) {
      if (item.ItemId?.toString() === itemId?.toString() || item.id === itemId)
        return item;
    }
  }

  // Fallback to MOCK_MENU
  for (const [_, meals] of Object.entries(MOCK_MENU)) {
    for (const mealArr of Object.values(meals)) {
      const found = mealArr.find(
        (i) => i.ItemId?.toString() === itemId?.toString() || i.id === itemId
      );
      if (found) return found;
    }
  }

  return null;
}

export function getImageUrl(itemNoOrName, size = "500x400") {
  if (!itemNoOrName) return "";

  const jpgPath = `/assets/${itemNoOrName}.jpg`;
  const jpegPath = `/assets/${itemNoOrName}.jpeg`;
  return jpgPath;
}
